import type { ReactNode } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    children: ReactNode;
    confirmLabel: string;
    destructive?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const ConfirmDialog = ({ open, title, children, confirmLabel, destructive = false, onConfirm, onClose }: ConfirmDialogProps) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText>{children}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button
                variant="contained"
                color={destructive ? "error" : "primary"}
                onClick={() => {
                    onClose();
                    onConfirm();
                }}
            >
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;
